import { render, staticRenderFns } from "./PageBlog.vue?vue&type=template&id=7807460e&scoped=true&"
import script from "./PageBlog.vue?vue&type=script&lang=js&"
export * from "./PageBlog.vue?vue&type=script&lang=js&"
import style0 from "./PageBlog.vue?vue&type=style&index=0&id=7807460e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7807460e",
  null
  
)

export default component.exports